import React, { FC, Fragment } from 'react';

import { GetFeedQueryVariables, Group } from 'api';
import { Layouts, Desktop, Mobile, EmptyState } from 'components';
import { Feed } from 'features/feed';

import { DesktopBanner, MobileBanner } from './Group';

interface IProps {
  group: Group;
  variables: GetFeedQueryVariables;
}

const GroupRemoved: FC<IProps> = ({ group, variables }) => {
  function renderFeed() {
    return (
      <Feed
        emptyState={() => <EmptyState name="groupRemoved" />}
        variables={variables}
        selectedGroup={group}
      />
    );
  }

  function renderBanner() {
    return (
      <Fragment>
        <Desktop>
          <DesktopBanner group={group} />
        </Desktop>
        <Mobile>
          <MobileBanner isFollowing group={group} />
        </Mobile>
      </Fragment>
    );
  }

  return (
    <Layouts.AppMain2Column
      desktopSplit="8/4"
      header={renderBanner()}
      left={renderFeed()}
      right={null}
    />
  );
};

export default GroupRemoved;
